import React from "react"
import styled from "styled-components/macro"

const MainStyles = styled.main`
  /* background: blue; */
  /* height: 50vh; */
  width: 100%;
`

const Main: React.FC = ({ children }) => {
  return <MainStyles role="main">{children}</MainStyles>
}

export default Main
